import {Component, OnInit, TemplateRef} from '@angular/core';
import {MemberModel} from '../../../models/user.model';
import {ActivatedRoute, Router} from '@angular/router';
import {AlertService} from '../../../services/notify/alert.service';
import {
    NavigationTableRequestModel,
    NavigationTableResponseItemModel,
    PaginationModel
} from '../../../models/file-table.model';
import {ModalService} from '../../../services/modal/modal.service';
import {HelpersService} from '../../../services/helpers.service';
import {UserControlService} from '../user-control/user-control.service';
import {MemberService} from '../../../services/member.service';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import {ModalSettingsModel} from '../../../models/modal.model';
import {DepartmentsService} from '../../../services/api/departments.service';
import {DivisionStructureModel, StructureDepartmentModel} from '../../../models/department.model';
import {BoardTableModel} from '../../../models/tasktable.model';
import {DocumentsServiceService} from '../../documents/documents-service.service';
import {AuthService} from '../../../services/api/auth.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-project-control-detail',
    templateUrl: './persons-control-detail.component.html',
    styleUrls: ['./persons-control-detail.component.scss'],
})
export class PersonsControlDetailComponent implements OnInit {
    allMembers: MemberModel[];
    public currentUserGuid: string;
    public loading = true;
    public profile: MemberModel;
    public requestMember: MemberModel;
    tab = 'profile';
    docTab = 'all';
    selectedFile: NavigationTableResponseItemModel;
    boards: BoardTableModel[];
    membersDepStructure: StructureDepartmentModel[];
    divisionSlider = [];

    departmentAccordions: {
        headerText: string,
        id: number,
        dataForTemplate: { divisions: DivisionStructureModel[] },
        editHeaderText: boolean,
    }[] = [];

    signs: { key: string, title: any }[];

    isLockButton = false;

    public pagination: PaginationModel = {limit: 10, current_page: 1};

    docPagination: NavigationTableRequestModel = new NavigationTableRequestModel();

    constructor(
        protected activatedRoute: ActivatedRoute,
        protected alertService: AlertService,
        protected router: Router,
        public modalService: ModalService,
        protected userControl: UserControlService,
        protected memberService: MemberService,
        public helper: HelpersService,
        private departmentsService: DepartmentsService,
        public controller: DocumentsServiceService,
        private authService: AuthService,
        public translate: TranslateService,
    ) {
        this.signs = [
            {key: 'proj_admin', title: this.translate.instant('USER_PROFILE.ROLE.proj_admin')},
            {key: 'inner', title: this.translate.instant('USER_PROFILE.ROLE.inner')},
            {key: 'outer', title: this.translate.instant('USER_PROFILE.ROLE.outer')},
            {key: 'blocked', title: this.translate.instant('USER_PROFILE.ROLE.blocked')},
        ];
        this.memberService.getCurrentMember().then(data => {
            this.requestMember = data;
        });

        this.activatedRoute.params.subscribe(params => {
            this.currentUserGuid = params.user_guid;

            this.memberService.getMemberGuid(this.currentUserGuid).subscribe({
                next: data => {
                    this.profile = data;
                    this.wrapAccess(data);
                    this.getMembersStructure();
                    this.docPagination.guid = this.profile.guid;
                },
                error: () => {
                    void this.router.navigate(['account', 'options', 'persons']);
                },
            });

            this.memberService.getAllMembers().then(data => {
                this.allMembers = data;
            });
        });
    }

    ngOnInit(): void {
        this.loading = false;
    }

    wrapAccess(data: MemberModel): void {
        this.signs = [
            {key: 'proj_admin', title: this.translate.instant('USER_PROFILE.ROLE.proj_admin')},
            {key: 'inner', title: this.translate.instant('USER_PROFILE.ROLE.inner')},
            {key: 'outer', title: this.translate.instant('USER_PROFILE.ROLE.outer')},
            {key: 'blocked', title: this.translate.instant('USER_PROFILE.ROLE.blocked')},
        ];

        this.signs = this.signs.filter(x => x.key !== data.project_setting.observation_type);
    }

    async removeFromProject(): Promise<any> {
        let modalSettings: ModalSettingsModel;
        modalSettings = {
            modalHeader: this.translate.instant('CONFIRM.HEADERS.REMOVE_USER'),
            buttonSubmit: this.translate.instant('CONFIRM.BUTTONS.YES'),
            buttonClose: this.translate.instant('CONFIRM.BUTTONS.NO'),
        };
        const modal = this.modalService.createFromSettings(modalSettings);
        modal.result.then(data => {
            if (data) {
                this.userControl.deleteUserFromProject(this.currentUserGuid).then(() => {
                    this.memberService.getMemberGuid(this.currentUserGuid).subscribe(res => {
                        this.wrapAccess(res);
                        this.profile = res;
                    });
                });
            }
        }).catch(() => {
            return;
        });
    }

    async updateProjectRights(rights: string, modal: NgbModalRef): Promise<any> {
        if (!rights) {
            return this.alertService.setAlert(this.translate.instant('ALERTS.SET_ROLE'), 'blue');
        }
        if (modal) {
            modal.close();
        }
        this.userControl.updateProjectRights(this.profile, rights).then(() => {
            this.memberService.getMemberGuid(this.currentUserGuid).subscribe(res => {
                this.profile = res;
                this.wrapAccess(res);
            });
        });
    }

    async updateProjectAdmin(key: string): Promise<any> {
        if (key === 'blocked') {
            void this.removeFromProject();
            return;
        }

        void this.updateProjectRights(key, null);
    }

    // sendEmit(): void {
    //     this.tab = 'tasks';
    //     this.emitReloadTasks.emit(true);
    // }

    getMembersStructure(): void {
        this.departmentsService.getStructureDepartments(this.profile.guid).subscribe({
            next: res => {
                this.departmentAccordions = [];
                this.membersDepStructure = res.departments;
                res.departments.forEach(dep => {
                    const newDepartment = {
                        headerText: dep.department_name,
                        id: dep.department_id,
                        dataForTemplate: {
                            divisions: dep.divisions,
                        },
                        editHeaderText: false,
                    };
                    this.departmentAccordions.push(newDepartment);
                });
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }

    onEventFind(request: any = null): void {
        this.controller.loadNav(this.controller.prepare(request));
    }

    async onEventTrClick(item: NavigationTableResponseItemModel = null, modal: TemplateRef<any>): Promise<any> {
        this.selectedFile = item;
        this.modalService.openTemplateModal(modal, 'xl');
    }

    editProfile(modal: NgbModalRef, newPhone?: string, newName?: string, newLastname?: string, newMiddlename?: string): void {
        const data = {
            firstname: newName ?? this.profile.firstname,
            middlename: newMiddlename ?? this.profile.middlename,
            lastname: newLastname ?? this.profile.lastname,
            phone: newPhone ?? this.profile.phone,
            lang: this.profile.language
        };
        this.authService.editUserProfile(data).subscribe({
            next: () => {
                if (modal) {
                    modal.close();
                }
                this.memberService.getMemberGuid(this.currentUserGuid).subscribe(res => {
                    this.wrapAccess(res);
                    this.profile = res;
                });
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }

    changeUser(member: MemberModel): void {
        this.tab = 'profile';
        void this.router.navigate(['account', 'options', 'persons', member.guid]);
    }

    redirectToBoardsSettings(): void {
        const modalSettings = {
            modalHeader: this.translate.instant('CONFIRM.HEADERS.ATTENTION'),
            modalBody: this.translate.instant('CONFIRM.TEXT.SETTINGS_BOARD'),
            buttonSubmit: this.translate.instant('CONFIRM.BUTTONS.YES'),
            buttonClose: this.translate.instant('CONFIRM.BUTTONS.NO'),
        };
        const modal = this.modalService.createFromSettings(modalSettings);
        modal.result.then(res => {
            if (res) {
                void this.router.navigate(['/account/tasks/options/statuses']);
            }
        }).catch(() => {
            return;
        });
    }

    redirectToDepartmentsSettings(): void {
        const modalSettings = {
            modalHeader: this.translate.instant('CONFIRM.HEADERS.ATTENTION'),
            modalBody: this.translate.instant('CONFIRM.TEXT.STRUCTURE_SETTINGS'),
            buttonSubmit: this.translate.instant('CONFIRM.BUTTONS.YES'),
            buttonClose: this.translate.instant('CONFIRM.BUTTONS.NO'),
        };
        const modal = this.modalService.createFromSettings(modalSettings);
        modal.result.then(res => {
            if (res) {
                void this.router.navigate(['/account/options/departments']);
            }
        }).catch(() => {
            return;
        });
    }

    editMemberPosition(newPosition: string): void {
        const data = {
            member_guid: this.profile.guid,
            position: newPosition,
        };
        this.authService.editMemberPosition(data).subscribe({
            next: () => {
                this.memberService.getMemberGuid(this.currentUserGuid).subscribe(res => {
                    this.wrapAccess(res);
                    this.profile = res;
                });
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }
}
